import { ConfirmDialog, titleCase } from '@westhetics/ui'
import { usePatientContact } from '@/features/anamneses/api'
import type { TreatmentPlan } from './api'
import { closeEffect, missingStagesSentence, stagesWithoutPhoto } from './labels'

/**
 * O modal de encerrar (RN-PLA-26): diz o efeito real (protocolo, hash, PDF, sem alterações), quem
 * recebe a cópia e as etapas que ficam sem foto (RN-PLA-25, P-PLA-10). Encerrar é irreversível:
 * a ação vai em plum. Carregando, o rótulo vira "Encerrando…".
 */
export function CloseDialog({
  plan,
  open,
  onOpenChange,
  onConfirm,
  loading,
  stagesError,
}: {
  plan: TreatmentPlan
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  loading: boolean
  /** O 422 em `fields.stages`: a lista do que falta, dita pela API. */
  stagesError?: string | null
}) {
  const contact = usePatientContact(open ? plan.patient.id : null)
  const missing = stagesWithoutPhoto(plan)
  const effect = [
    closeEffect(plan, contact.data?.email ?? null),
    stagesError ?? missingStagesSentence(missing),
  ]
    .filter(Boolean)
    .join(' ')
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={(next) => {
        if (!loading) onOpenChange(next)
      }}
      title={`Encerrar o plano de ${titleCase(plan.patient.name)}?`}
      effect={effect}
      confirmLabel={missing.length > 0 || stagesError ? 'Encerrar mesmo assim' : 'Encerrar plano'}
      loading={loading}
      loadingLabel="Encerrando…"
      onConfirm={onConfirm}
    />
  )
}
